import React from "react";
import { Button, Input, Modal, ModalBody, ModalHeader } from "reactstrap";
import { EmployeeAdvance } from "features/EmployeeAdvances/types/employee-advance.types";

interface CancelModalProps {
  show?: boolean;
  reason: string;
  onReasonChange: (value: string) => void;
  onCancelClick?: () => void;
  onCloseClick?: () => void;
  record?: EmployeeAdvance | null;
}

const CancelModal = ({
  show,
  reason,
  onReasonChange,
  onCancelClick,
  onCloseClick,
  record,
}: CancelModalProps) => {
  return (
    <React.Fragment>
      <Modal fade={true} isOpen={show} toggle={onCloseClick} centered>
        <ModalHeader className="modal-title">#{record?.code}</ModalHeader>
        <ModalBody className="text-center p-5">
          <i className="ri-close-circle-line display-5 text-danger"></i>
          <div className="mt-4">
            <h4 className="mb-3">Confirm Cancellation</h4>
            <p className="text-muted mb-4">
              This reverses the disbursement by cancelling the linked payment.
              The payment must still be posted with zero settlements.
            </p>
            <Input
              type="textarea"
              rows="3"
              className="form-control mb-3"
              placeholder="Please provide a reason for cancellation (optional)"
              value={reason}
              onChange={(e) => onReasonChange(e.target.value)}
            />
            <div className="hstack gap-2 justify-content-center">
              <Button color="light" onClick={onCloseClick}>
                Close
              </Button>
              <Button color="danger" onClick={onCancelClick}>
                Cancel Advance
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default CancelModal;
